interface CircularProgressProps {
  percentage: number;
  size?: number;
}

export function CircularProgress({ percentage, size = 64 }: CircularProgressProps) {
  // Calculate stroke-dashoffset based on percentage
  // Circle circumference for r=16 is approximately 100.53
  // We use 100 for simplicity in calculations
  const strokeDashoffset = 100 - percentage;

  return (
    <div className="relative shrink-0" style={{ width: size, height: size }}>
      <svg
        className="h-full w-full"
        width="36"
        height="36"
        viewBox="0 0 36 36"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Background circle */}
        <circle
          className="stroke-slate-200 dark:stroke-slate-700"
          cx="18"
          cy="18"
          r="16"
          fill="none"
          strokeWidth="3"
        />
        {/* Progress circle */}
        <circle
          className="stroke-primary"
          cx="18"
          cy="18"
          r="16"
          fill="none"
          strokeWidth="3"
          strokeDasharray="100"
          strokeDashoffset={strokeDashoffset}
          strokeLinecap="round"
          transform="rotate(-90 18 18)"
        />
      </svg>
      {/* Percentage text */}
      <div className="absolute inset-0 flex items-center justify-center">
        <span className="text-sm font-bold text-slate-900 dark:text-white">
          {percentage}%
        </span>
      </div>
    </div>
  );
}
